(function () {
  'use strict';

  var MONEY_FALLBACK = '{{amount_no_decimals_with_comma_separator}}';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme && theme.moneyFormat ? theme.moneyFormat : MONEY_FALLBACK);
    }
    var amount = typeof cents === 'number' ? cents : parseFloat(cents);
    if (isNaN(amount)) return '';
    return (amount / 100).toFixed(2);
  }

  var UNIT_FACTORS = {
    ml: { factor: 1, label: 'ml' },
    l: { factor: 1000, label: 'ml' },
    g: { factor: 1, label: 'g' },
    kg: { factor: 1000, label: 'g' },
    oz: { factor: 29.57, label: 'ml' }
  };

  function parseVariantQuantity(title) {
    if (!title) return null;
    var match = title.toLowerCase().match(/([\d.,]+)\s*(ml|g|kg|l|oz)/);
    if (!match) return null;
    var value = parseFloat(match[1].replace(',', '.'));
    if (isNaN(value)) return null;
    var unit = match[2];
    var settings = UNIT_FACTORS[unit];
    if (!settings) return null;
    return {
      quantity: value * settings.factor,
      unitLabel: settings.label
    };
  }

  function parseProductJSON(sectionId) {
    var jsonEl = document.getElementById('ProductJson-' + sectionId);
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (err) {
      console.warn('Unable to parse product JSON', err);
      return null;
    }
  }

  function togglePoliciesVisibility(section) {
    var policies = section.querySelector('[data-product-policies]');
    var addToCart = section.querySelector('[data-add-to-cart]');
    if (!policies || !addToCart) return;
    var observer = new MutationObserver(function () {
      var disabled = addToCart.getAttribute('aria-disabled') === 'true';
      policies.classList.toggle('is-hidden', disabled);
    });
    observer.observe(addToCart, { attributes: true, attributeFilter: ['aria-disabled'] });
    var initialDisabled = addToCart.getAttribute('aria-disabled') === 'true';
    policies.classList.toggle('is-hidden', initialDisabled);
  }

  function initVariantCards(section) {
    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;

    var templateSuffix = section.getAttribute('data-template-suffix');

    var productData = parseProductJSON(sectionId);
    if (!productData || !productData.variants) return;

    var cardsContainer = section.querySelector('[data-variant-card-list]');
    var hasCards = !!cardsContainer;

    var productForm = section.querySelector('form[data-product-form]');
    if (!productForm) return;

    var hiddenVariantSelect = productForm.querySelector('select[name="id"]');
    var optionSelectors = productForm.querySelectorAll('.single-option-selector');
    var addToCartPrice = section.querySelector('[data-add-to-cart-price]');

    var cardsMap = {};
    var variantsWithQuantity = productData.variants.map(function (variant) {
      var parsedQuantity = parseVariantQuantity(variant.title);
      return Object.assign({}, variant, {
        __quantity: parsedQuantity ? parsedQuantity.quantity : null,
        __unitLabel: parsedQuantity ? parsedQuantity.unitLabel : null
      });
    });

    if (hasCards) {
      cardsContainer.querySelectorAll('.variant-card').forEach(function (button) {
        var variantId = Number(button.dataset.variantId);
        var unitTarget = button.querySelector('[data-variant-unit]');
        var badgeTarget = button.querySelector('[data-variant-badge]');
        cardsMap[variantId] = {
          button: button,
          unitTarget: unitTarget,
          badgeTarget: badgeTarget
        };

        var variantData = variantsWithQuantity.find(function (variant) {
          return Number(variant.id) === variantId;
        });

        if (variantData && unitTarget) {
          if (variantData.__quantity && variantData.__unitLabel) {
            var perUnitCents = Math.round(variantData.price / variantData.__quantity);
            unitTarget.textContent = '(' + formatMoney(perUnitCents) + ' / ' + variantData.__unitLabel + ')';
          } else {
            unitTarget.textContent = '';
          }
        }
      });
    }

    var bestValueVariant = variantsWithQuantity.reduce(function (best, variant) {
      if (!variant.available || !variant.__quantity) return best;
      var ratio = variant.price / variant.__quantity;
      if (!best || ratio < best.ratio) {
        return { id: variant.id, ratio: ratio };
      }
      return best;
    }, null);

    var tryMeVariant = variantsWithQuantity.reduce(function (best, variant) {
      if (!variant.available) return best;
      if (!best || variant.price < best.price) {
        return { id: variant.id, price: variant.price };
      }
      return best;
    }, null);

    function resetBadges() {
      if (!hasCards) return;
      Object.keys(cardsMap).forEach(function (key) {
        var entry = cardsMap[key];
        if (!entry || !entry.badgeTarget) return;
        entry.badgeTarget.textContent = '';
        entry.badgeTarget.classList.remove('is-visible', 'variant-card__badge--value', 'variant-card__badge--try');
      });
    }

    function findVariantById(id) {
      var numericId = Number(id);
      return productData.variants.find(function (variant) {
        return Number(variant.id) === numericId;
      });
    }

    function setActiveCard(variantId) {
      if (!hasCards) return;
      var buttons = cardsContainer.querySelectorAll('.variant-card');
      buttons.forEach(function (button) {
        var isActive = Number(button.dataset.variantId) === Number(variantId);
        button.classList.toggle('is-active', isActive);
        if (!button.disabled) {
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    }

    function applyBadges() {
      if (!hasCards) return;
      resetBadges();

      if (bestValueVariant && cardsMap[bestValueVariant.id]) {
        var target = cardsMap[bestValueVariant.id].badgeTarget;
        if (target) {
          target.textContent = (window.theme && theme.productStrings && theme.productStrings.bestValue) || 'Best Value';
          target.classList.add('is-visible', 'variant-card__badge--value');
        }
      }

      if (tryMeVariant && cardsMap[tryMeVariant.id] && (!bestValueVariant || tryMeVariant.id !== bestValueVariant.id)) {
        var tryTarget = cardsMap[tryMeVariant.id].badgeTarget;
        if (tryTarget) {
          tryTarget.textContent = (window.theme && theme.productStrings && theme.productStrings.tryMe) || 'Try Me';
          tryTarget.classList.add('is-visible', 'variant-card__badge--try');
        }
      }
    }

    function updateButtonPrice(variant) {
      if (!addToCartPrice) return;

      if (variant && variant.available) {
        addToCartPrice.textContent = formatMoney(variant.price);
        addToCartPrice.classList.remove('is-hidden');
      } else {
        addToCartPrice.textContent = '';
        addToCartPrice.classList.add('is-hidden');
      }
    }

    function selectVariantFromCard(button) {
      if (!button || button.disabled) return;

      var variantId = button.dataset.variantId;
      var variant = findVariantById(variantId);
      if (!variant) return;

      optionSelectors.forEach(function (selector, index) {
        var optionValue = button.getAttribute('data-option' + (index + 1));
        if (optionValue && selector.value !== optionValue) {
          selector.value = optionValue;
          selector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      if (hiddenVariantSelect && hiddenVariantSelect.value !== variantId) {
        hiddenVariantSelect.value = variantId;
        hiddenVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      setActiveCard(variantId);
      updateButtonPrice(variant);
    }

    if (hasCards) {
      cardsContainer.addEventListener('click', function (event) {
        var target = event.target.closest('.variant-card');
        if (!target || !cardsContainer.contains(target)) return;
        event.preventDefault();
        selectVariantFromCard(target);
      });

      cardsContainer.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var target = event.target.closest('.variant-card');
        if (!target || !cardsContainer.contains(target)) return;
        event.preventDefault();
        selectVariantFromCard(target);
      });
    }

    section.addEventListener('variantChange', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) {
        updateButtonPrice(null);
        setActiveCard(null);
        return;
      }
      setActiveCard(variant.id);
      updateButtonPrice(variant);
    });

    // Initial variant:
    // - Default template (with cards): use current select / first variant (behaviour unchanged)
    // - `card-variants` template (dropdown only): force the cheapest available variant
    var initialVariant = null;
    if (templateSuffix === 'card-variants') {
      var cheapest = productData.variants.reduce(function (best, variant) {
        if (!variant.available) return best;
        if (!best || variant.price < best.price) {
          return { id: variant.id, price: variant.price };
        }
        return best;
      }, null);

      if (cheapest) {
        initialVariant = findVariantById(cheapest.id);
        if (hiddenVariantSelect && String(hiddenVariantSelect.value) !== String(cheapest.id)) {
          hiddenVariantSelect.value = String(cheapest.id);
          hiddenVariantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        var fallbackId = hiddenVariantSelect ? hiddenVariantSelect.value : productData.variants[0].id;
        initialVariant = findVariantById(fallbackId);
      }
    } else {
      var initialVariantId = hiddenVariantSelect ? hiddenVariantSelect.value : productData.variants[0].id;
      initialVariant = findVariantById(initialVariantId);
    }

    if (initialVariant) {
      setActiveCard(initialVariant.id);
      updateButtonPrice(initialVariant);
    } else {
      updateButtonPrice(null);
    }

    applyBadges();
  }

  function init() {
    var productSections = document.querySelectorAll('[data-section-type="product"]');
    productSections.forEach(function (section) {
      initVariantCards(section);
      togglePoliciesVisibility(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
